export enum EventType {
    Normal = 1,
    Continuous,
    Voucher,
}
